define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BookingStatus = void 0;
    var BookingStatus;
    (function (BookingStatus) {
        BookingStatus["PENDING"] = "pending";
        BookingStatus["ACCEPTED"] = "accepted";
        BookingStatus["ASSIGNED"] = "assigned";
        BookingStatus["INACTIVE"] = "inactive";
        BookingStatus["CANCELED"] = "canceled";
        BookingStatus["COMPLETED"] = "completed";
    })(BookingStatus = exports.BookingStatus || (exports.BookingStatus = {}));
});
